import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { HtmlTooltip } from 'components/tooltips/HtmlTootip';
import AddIcon from '@mui/icons-material/Add';
import { HeaderCardStyled } from './styles';
import { useStyles } from 'components/Styles';

function HeaderCard({ title, tooltipText, handleAdd }) {
  const classes = useStyles();
  return (
    <HeaderCardStyled>
      <Box>
        {title}
        {tooltipText && (
        <HtmlTooltip
          sx={{ marginLeft: -0.5 }}
          title={tooltipText}
          placement="right"
          arrow
          interactive
        >
          <InfoIcon color="primary" fontSize="inherit" />
        </HtmlTooltip>
        )}
      </Box>
      {handleAdd
      && (
        <Tooltip
          title="Adicionar"
        >
          <Box
            className={classes.addRecordLineButton}
            onClick={handleAdd}
          >
            <IconButton sx={{ padding: 0 }}>
              <AddIcon sx={{ color: 'white', fontSize: 35 }} />
            </IconButton>
          </Box>
        </Tooltip>
      )}
    </HeaderCardStyled>
  );
}

export default HeaderCard;
